import ConfigurableUrl from '@engine/features/configurable_urls';
import WpfLocaleText from '@engine/features/merchant/merchant_wpf_locale_texts';
import { exists } from '@engine/lib/utility/exists';
var CONFIRMABLES = {
  ConfigurableUrl: ConfigurableUrl,
  WpfLocaleText: WpfLocaleText
};

function modalDialog(selector) {
  var $modal = $(selector);
  var submitButton = $modal.find('input[type="submit"]');
  var modalTitle = $modal.find('.modal-title');
  var defaultTitle = modalTitle.text();
  var data = null;

  function callActionChain() {
    var actionChain = data.action.split('.');
    var method = null;
    actionChain.forEach(function (action, index) {
      if (method) {
        method = method[action];
      } else {
        method = CONFIRMABLES[action];
      }

      if (index === actionChain.length - 1) {
        method(data.id, data.href, data.type);
      }
    });
  }

  $modal.on('show.bs.modal', function (e) {
    var target = $(e.relatedTarget);
    data = target.data();

    if (typeof target.data('title') !== 'undefined') {
      modalTitle.html(data.title);
    } else {
      modalTitle.html(defaultTitle);
    }
  });
  submitButton.on('click', function (e) {
    var shouldDismiss = true;
    e.preventDefault();

    if (typeof submitButton.data('dismiss') !== 'undefined') {
      shouldDismiss = submitButton.data('dismiss');
    }

    callActionChain();

    if (shouldDismiss) {
      $modal.modal('hide');
    }
  });
}

function initialize() {
  var modalSelectors = ['#email-template-modal', '#notification-urls-modal', '#return-urls-modal', '#footer-text-modal', '#tac-and-policy-modal', '#wpf-purchase-summary-modal'];
  modalSelectors.forEach(function (selector) {
    if (exists(selector)) {
      modalDialog(selector);
    }
  });
}

var Modal = {
  initialize: initialize
};
export default Modal;